import { motion } from "framer-motion";

export function LegalLayout({ title, updated, children }) {
  return (
    <>
      <section className="relative overflow-hidden gradient-emerald">
        <div className="grain absolute inset-0 opacity-40" />
        <div className="relative mx-auto max-w-3xl px-5 pb-12 pt-36 sm:px-8 md:pt-44">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
              Legal
            </span>
            <h1 className="mt-5 font-display text-4xl font-light leading-none tracking-tighter md:text-5xl">
              {title}
            </h1>
            {updated && (
              <p className="mt-4 text-sm text-muted-foreground">Last updated: {updated}</p>
            )}
          </motion.div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 pb-24 sm:px-8">
        <div className="legal-content space-y-5 text-base leading-relaxed text-muted-foreground [&_h2]:mt-10 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-medium [&_h2]:tracking-tight [&_h2]:text-foreground [&_a]:font-medium [&_a]:text-primary [&_a:hover]:underline [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-6 [&_strong]:text-foreground">
          {children}
        </div>
      </section>
    </>
  );
}
